import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  /* background: linear-gradient(135deg, #6a11cb, #2575fc); */
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 20px; */
`;


export const Card = styled.div`
  width: 420px;
  background: rgba(255, 255, 255, 0.95);
  padding: 40px 35px;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  text-align: center;
`;


export const LogoBox = styled.div`
  width: 70px;
  height: 70px;
  background: #7b4bff;
  border-radius: 20px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;


export const Title = styled.h1`
  margin-top: 20px;
  font-size: 28px;
  font-weight: 700;
  color: #333;
`;


export const SubTitle = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 30px;
`;


export const Toggle = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 25px;
`;


export const ToggleButton = styled.button<{ active?: boolean }>`
  flex: 1;
  padding: 10px 0;
  border: none;
  background: ${(p) => (p.active ? "#e8e8ff" : "transparent")};
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
`;


export const InputBox = styled.div`
  width: 100%;
  margin-bottom: 18px;
  position: relative;
`;


export const Input = styled.input`
  width: 100%;
  padding: 12px 12px 12px 40px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 14px;
`;


export const Icon = styled.div`
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  color: #555;
`;

export const Submit = styled.button`
  width: 102%;
  margin-top: 10px;
  padding: 12px;
  background: linear-gradient(90deg, #4d2cff, #8a4fff);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
`;


export const Footer = styled.p`
  margin-top: 20px;
  font-size: 12px;
  color: #555;
`;